import { useApi } from '@/services/api/useApi';
import { useExitHandler } from '@/utils/useExitHandler/useExitHandler';

export default function refreshSession(
  product: string,
  suffix?: URLSearchParams,
  fullPath?: string,
): void {
  // try get current base url path or fall back to /
  const currentBasePath = import.meta.env.VITE_APP_BASE_URL || '/';

  let redirect: string;
  if (fullPath !== undefined) {
    // Use the full path including route parameters
    const queryString = suffix?.toString() ?? '';
    redirect = `${window.location.origin}${currentBasePath}${fullPath.replace(/^\//, '')}${queryString ? '?' + queryString : ''}`;
  } else {
    redirect = `${window.location.origin}${currentBasePath}${product}?${
      suffix?.toString() ?? ''
    }`;
  }

  useExitHandler().disable();

  window.location.href = `${useApi().getBaseUrl()}/${product}/login?redirect=${encodeURIComponent(
    redirect,
  )}&refresh=1`;
}
